module.exports = {
      id: "angle-up-usage",
      viewBox: "0 0 320 512",
      url: "/" + "sprite-a5f842c290447276eba09a9bdedabd59.svg#angle-up",
      toString: function () {
        return this.url;
      }
    }